@use "@styles/variables";

.transaction-amount {
    white-space: nowrap;
}

.color:is(.credit):not(.failed) {
    color: variables.$gray-900;
}

.color:is(.failed) {
    color: variables.$gray-900;
    text-decoration-line: line-through;
}
